import React from 'react';
import './GeneratingLoader.css';

function GeneratingLoader() {
  return (
    <div className="generating-card">
      <div className="generating-loader">
        <div className="generating-label">Growth Iq is </div>
        <div className="generating-words">
          <span className="generating-word">Thinking</span>
          <span className="generating-word">Analyzing</span>
          <span className="generating-word">Synthesizing</span>
          <span className="generating-word">Generating</span>

        </div>
      </div>
    </div>
  );
}

export default GeneratingLoader;
